// extracted by mini-css-extract-plugin
export var buttons = "_bg-0";
export var buttonsActive = "_bg-h";
export var cancelConfirm = "_bg-1";
export var closeButton = "_bg-2";
export var column = "_bg-3";
export var container = "_bg-4";
export var detailHeader = "_bg-6";
export var detailTitle = "_bg-7";
export var detailsContent = "_bg-5";
export var header = "_bg-8";
export var headerWithClose = "_bg-9";
export var icon = "_bg-a";
export var infoIcon = "_bg-c";
export var informationContainer = "_bg-b";
export var sideDrawer = "_bg-d";
export var sideDrawerOpen = "_bg-e";
export var stickyFooter = "_bg-f";
export var typeOption = "_bg-g";